import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "ariaLabel", "children", "colorToken", "colorTokenArgs", "direction", "href", "id", "isUnderlined", "numberOfLines", "onPress", "rel", "role", "target", "testID", "textToken", "textTokenArgs", "textAlignToken", "textAlignTokenArgs", "UNSAFE_props"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import useTextStyle from '@bubble-ui/hook-use-text-style';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { isNative } from '@bubble-ui/util-platform';
import { defaultDesignTokens } from './defaultDesignTokens';
import { Link as LinkComponent } from './Link';
var getDisplayName = element => {
  var _element$type;
  return (// @ts-expect-error
    element === null || element === void 0 ? void 0 : (_element$type = element.type) === null || _element$type === void 0 ? void 0 : _element$type.displayName
  );
};
var Link = _ref => {
  var {
      align,
      ariaLabel,
      children,
      colorToken = 'link/text-color',
      colorTokenArgs,
      direction,
      href,
      id,
      isUnderlined,
      numberOfLines = 0,
      onPress,
      rel,
      role,
      target,
      testID,
      textToken = 'link/text-style',
      textTokenArgs,
      textAlignToken = 'link/text-alignment',
      textAlignTokenArgs,
      UNSAFE_props
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'Link',
    propName: 'align',
    shouldWarn: align !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'textAlignToken'
  });
  var [interactiveState, eventHandlers] = useInteractiveStateCombined(restProps);
  var designContext = useDesignContext(defaultDesignTokens);
  var isUnderlinedFinal = isUnderlined !== undefined ? isUnderlined : designContext.get('link/text-underlined');
  var textStyle = useTextStyle({
    align,
    colorToken,
    colorTokenArgs: _objectSpread({
      interactiveState: interactiveState.interactiveState
    }, colorTokenArgs),
    designTokens: defaultDesignTokens,
    direction,
    numberOfLines,
    textDecorationLine: isUnderlinedFinal ? 'underline' : 'none',
    textToken,
    textTokenArgs,
    textAlignToken,
    textAlignTokenArgs
  });
  var nativeAttrs =
  // Ellipsis styling for web is handled by useTextStyle 👆
  isNative ? {
    numberOfLines,
    ellipsizeMode: 'tail'
  } : {};
  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    id: id,
    testID: testID
  }, UNSAFE_props, nativeAttrs, eventHandlers, {
    ariaLabel: ariaLabel,
    href: href,
    target: target,
    onPress: onPress,
    disabled: interactiveState.disabled,
    rel: rel,
    role: role,
    style: _objectSpread(_objectSpread(_objectSpread({}, textStyle), interactiveState.keyboardFocused && !isNative ? {
      outlineStyle: 'solid',
      outlineWidth: 2,
      outlineColor: designContext.get('link/keyboard-focus-border-color').toString(),
      outlineOffset: 3,
      borderRadius: designContext.get('link/keyboard-focus-corner-radius').pixelValue
    } : {
      outline: 0
    }), interactiveState.disabled ? {} : {
      cursor: 'pointer'
    })
  }), React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child) || typeof child !== 'object') {
      return child;
    }
    var childAsElement = child;
    if (getDisplayName(child) === 'Typography') {
      return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
        context: designContext
      }, /*#__PURE__*/React.cloneElement(childAsElement, {
        colorToken: childAsElement.props.colorToken || colorToken,
        colorTokenArgs: childAsElement.props.colorTokenArgs || _objectSpread({
          interactiveState: interactiveState.interactiveState
        }, colorTokenArgs),
        textToken: childAsElement.props.textToken || textToken,
        textTokenArgs: childAsElement.props.textTokenArgs || textTokenArgs
      }));
    }
    return child;
  }));
};
Link.displayName = 'Link';
export default Link;
//# sourceMappingURL=index.js.map